import { PaymentGatewayIntegration } from '../..';

import cvc from './elements/cvc.vue';
import creditCard from './elements/creditCard.vue';
import expiry from './elements/expiry.vue';

enum GateEnv {
    Live = 'live',
    Test = 'test',
}

interface GateConfig {
    locale: string;
    environment: GateEnv;
    clientKey: string;
}

const GateURL = {
    [GateEnv.Live]: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/3.18.2/adyen.js',
    [GateEnv.Test]: 'https://checkoutshopper-test.adyen.com/checkoutshopper/sdk/3.18.2/adyen.js',
};

// maps Adyen brand names to those used on MFD
const cardAdapter = (card: string) => {
    const map = {
        mc: 'master',
    };
    return map[card] || card;
};

export default class Adyen extends PaymentGatewayIntegration {
    public name = 'Adyen';
    public scriptUrl = '';
    public fields = {
        cvc,
        creditCard,
        expiry,
    };

    public integrationFields = {
        elements: Function,
        adyen: {},
    };

    private clientData: string = '';
    private encryptedData: string = '';
    private isValidState: boolean = false;
    private brand: string | undefined = 'card'; // 'card' value set by Adyen when the card is not detected

    public async created() {
        const configuration: GateConfig = {
            locale: 'en_US',
            environment: this.integrationData.env || GateEnv.Live,
            clientKey: this.integrationData.publishable_key,
        };

        this.scriptUrl = this.getScriptURL(configuration.environment);

        await this.loadScript();
        if (!window.AdyenCheckout) {
            this.vm.failed = true;
        }

        const styleObject = {
            base: {
                color: '#000',
                fontSize: '14px',
                lineHeight: '14px',
                fontSmoothing: 'antialiased',
            },
            error: {
                color: 'red',
            },
            placeholder: {
                color: '#999',
                fontWeight: 400,
                opacity: 1,
            },
            validated: {
                color: '#000',
            },
        };

        const checkout = new window.AdyenCheckout(configuration);
        checkout.create('securedfields', {
            // Optional configuration
            type: 'card',
            styles: styleObject,
            onChange: (state, component) => {
                this.clientData = state.isValid ? state.data.riskData.clientData : '';
                this.encryptedData = state.isValid ? state.data.paymentMethod : '';
                this.isValidState = state.isValid && Boolean(this.clientData) && Boolean(this.encryptedData);

                const ccRef: any = this.vm.$refs.creditCard;
                const brand = cardAdapter(component.state.brand);

                ccRef.input.brand = brand === 'card' ? null : brand;

                ccRef.$emit('valid', this.isValidState);
                ccRef.$refs.input.dispatchEvent(new CustomEvent('change', { detail: { brand } }));
            },
        }).mount('#ccFormPGW');


        this.vm.loading = false;
    }

    public async serialize(additionalsGot: any) {
        if (this.isValidState && Boolean(this.clientData) && Boolean(this.encryptedData)) {
            return this.postSerialize(additionalsGot, {
                token_data: {
                    clientData: this.clientData,
                    encryptedData: this.encryptedData,
                },
            });
        } else {
            throw new Error('Validation card goes wrong! Check card data');
        }
    }

    private getScriptURL = (env: string): string => {
        if (GateURL[env]) {
            return GateURL[env] as string;
        }
        throw Error('Unsupported environment key. Site URL can not be found.');
    }
}
